import {
  getBarAPI,
  getCitiesAPI,
  getCitiesWithTheatresAPI,
  getFilmsAPI,
  getFilmsBasicAPI,
  getFilmWthScheduleAPI,
  getHallStatusAPI,
  getNotificationsAPI,
  getScheduleAPI,
  getScheduleByDateAPI,
  getSessionPricesAPI,
  getSoonAPI,
  getSoonByFilmAPI,
  getTheatreAPI,
  getTheatresByCityAPI,
  getTheatrePaymentInfoAPI,
  getPrivacyDocumentsAPI
} from '../helpers/api';
import store from '../store/store';
import request from '../helpers/request';

export const getTheatre = async (theatreId) => {
  return await request(getTheatreAPI({ theatreId }));
};

export const getTheatrePaymentInfo = async (data) => {
  return await request(getTheatrePaymentInfoAPI(data));
};

export const getNotifications = async (data) => {
  return await request(getNotificationsAPI(data));
};

export const getCities = async () => await request(getCitiesAPI());

export const getCitiesWithTheatres = async (data) =>
  await request(getCitiesWithTheatresAPI(data));

export const getTheatresByCity = async (data) =>
  await request(getTheatresByCityAPI(data));

export const getSchedule = async (data, userSessionGuid) =>
  await request(
    getScheduleAPI(data),
    'GET',
    {},
    { frontType: store.getters.frontType, userSessionGuid },
  );

export const getScheduleByDate = async (data, userSessionGuid) => {
  return await request(getScheduleByDateAPI(), 'POST', data, {
    frontType: store.getters.frontType,
    userSessionGuid,
  });
};

export const getFilmWthSchedule = async (data, userSessionGuid) => {
  return await request(getFilmWthScheduleAPI(data), 'GET', undefined, {
    frontType: store.getters.frontType,
    userSessionGuid,
  });
};

export const getSoon = async (data) => await request(getSoonAPI(), 'GET', data);

export const getSoonByFilm = async (data) =>
  await request(getSoonByFilmAPI(), 'GET', data);

export const getFilms = async (data) =>
  await request(getFilmsAPI(), 'GET', data);

export const getFilmBasic = async (data) =>
  await request(getFilmsBasicAPI(data), 'GET', data);

export const getSessionPrices = async (data) =>
  await request(getSessionPricesAPI(data));

export const getHallStatus = async (data) =>
  await request(getHallStatusAPI(data));

export const getBar = async (data) => await request(getBarAPI(data));
export const getPrivacyDocuments = async (data) => 
  await request(getPrivacyDocumentsAPI(data), 'GET', null);
